/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_10tb_StorageInputs */



/**
* | output |
* | --- |
* | "oneCloud, OneDrive, Google Drive & GitHub integration" |
*
* @param {Pricing_Feature_10tb_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_10tb_storage = /** @type {((inputs?: Pricing_Feature_10tb_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_10tb_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneCloud, OneDrive, Google Drive & GitHub Integration")
	return /** @type {LocalizedString} */ ("oneCloud, OneDrive, Google Drive & GitHub integration")
});